import { useEffect, useState } from 'react';
import { ASSISTANT_MIN_VIEWPORT_PX } from './constants';

const QUERY = `(min-width: ${ASSISTANT_MIN_VIEWPORT_PX}px)`;

/**
 * Whether the viewport is wide enough for the assistant.
 *
 * The panel is a fixed-position column beside the form; below this width it would cover the step
 * it is meant to help with. Gating here rather than hiding with CSS keeps the launcher, the panel
 * and the error hand-off link consistent — all three read `isEnabledOnStep`, so none of them can
 * offer a chat the customer cannot usefully open.
 *
 * Starts false so the server/first paint never flashes a launcher that is about to be removed.
 */
export function useIsAssistantViewport(): boolean {
  const [isWideEnough, setIsWideEnough] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const query = window.matchMedia(QUERY);
    const sync = () => setIsWideEnough(query.matches);
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  return isWideEnough;
}
